<template>
  <PageLayout :page-title="$t('search.title')" banner-key="news">
    <div class="cpjzDiv">
      <div class="wrap">
        <div class="bdDiv flexbet">
          <div class="blDiv">
            <div class="searchDiv">
              <form @submit.prevent="submitSearch">
                <i class="font_family icon-sousuo"></i>
                <input v-model="inputKeyword" type="text" :placeholder="$t('searchPlaceholder')">
              </form>
            </div>
            <ProductSidebar />
          </div>

          <div class="brDiv">
            <div class="nyTitle wow fadeInUp tl">
              <span class="f48">{{ $t('search.currentSearch') }}{{ keyword }}</span>
            </div>

            <div class="rowDiv">
              <div v-if="results.length" class="row">
                <div
                  v-for="item in results"
                  :key="item.id + '-' + item.kind"
                  class="col-md-4 col-sm-6 col-12"
                >
                  <router-link :to="item.link" class="imgH">
                    <div class="imgDiv imgObj">
                      <div class="pic">
                        <img v-if="item.image" :src="item.image" :alt="item.title">
                      </div>
                    </div>
                    <div class="textDiv">
                      <div class="title">{{ item.title }}</div>
                      <div class="moreBtn flexcen">
                        {{ $t('common.learnMore') }}
                        <i class="font_family icon-youjiantou"></i>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <p v-else-if="keyword" style="text-align:center;color:#999;padding:48px 0">{{ $t('search.noResults') }}</p>
              <p v-else style="text-align:center;color:#999;padding:48px 0">{{ $t('searchPlaceholder') }}</p>

              <PagePagination
                :page="pageNum"
                :total="total"
                :page-size="pageSize"
                @change="onPageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/hirays/PageLayout.vue'
import ProductSidebar from '@/components/hirays/ProductSidebar.vue'
import PagePagination from '@/components/hirays/PagePagination.vue'
import { listNews, listProduct, listProductCategory } from '@/utils/http'
import { unwrapRows, mapNewsItem, resolveImageUrl } from '@/utils/content'
import { DEFAULT_PAGE_SIZE, unwrapTotal, scrollToListTop } from '@/utils/pagination'

export default {
  components: { PageLayout, ProductSidebar, PagePagination },
  data() {
    return {
      keyword: '',
      inputKeyword: '',
      results: [],
      categories: [],
      pageNum: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      total: 0
    }
  },
  watch: {
    '$route.query.q': {
      immediate: true,
      handler(q) {
        this.keyword = (q || '').trim()
        this.inputKeyword = this.keyword
        this.pageNum = 1
        this.search()
      }
    }
  },
  methods: {
    reloadCmsData() {
      this.search()
    },

    submitSearch() {
      const q = this.inputKeyword.trim()
      if (!q) return
      if (q === this.keyword && this.$route.query.q === q) {
        this.pageNum = 1
        this.search()
        return
      }
      this.$router.push({ path: '/search/', query: { q } })
    },

    async search() {
      if (!this.keyword) {
        this.results = []
        this.total = 0
        return
      }

      try {
        const catRes = await listProductCategory({ status: 1, pageNum: 1, pageSize: 50 }, this.$i18n.locale)
        this.categories = unwrapRows(catRes)

        const newsRes = await listNews({
          status: 1,
          keyword: this.keyword,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }, this.$i18n.locale)
        const newsRows = unwrapRows(newsRes).map(mapNewsItem)
        const newsTotal = unwrapTotal(newsRes)

        if (newsRows.length || newsTotal > 0) {
          this.results = newsRows.map(item => ({
            id: item.id,
            kind: 'news',
            title: item.title,
            image: item.image || '',
            link: '/news/' + item.category + '/' + item.id + '.html'
          }))
          this.total = newsTotal || newsRows.length
          return
        }

        const prodRes = await listProduct({
          status: 1,
          keyword: this.keyword,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }, this.$i18n.locale)
        const products = unwrapRows(prodRes)
        this.results = products.map(p => ({
          id: p.id,
          kind: 'product',
          title: p.productName,
          image: resolveImageUrl(String(p.picUrl || '').split(',')[0]) || '',
          link: this.productLink(p)
        }))
        this.total = unwrapTotal(prodRes) || products.length
      } catch (e) {
        this.results = []
        this.total = 0
      }
    },

    productLink(p) {
      const cat = this.categories.find(c => c.id === p.categoryId)
      const slug = cat ? cat.categorySlug : 'all'
      return '/product/' + slug + '/' + p.id + '.html'
    },

    onPageChange(page) {
      this.pageNum = page
      this.search()
      scrollToListTop(this.$el.querySelector('.brDiv'))
    }
  }
}
</script>
